import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const CircularIndeterminate = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default CircularIndeterminate;